module.exports = __webpack_public_path__ + "media/images/sail-7f740c42f31798ee2a1f4f45fc3250e1.png";